import React from "react"
import PropTypes from "prop-types"
import { Button as ReactStrapButton, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import TreeContainer from "../layout/checkbox-tree/TreeContainer"
import styled from "styled-components"
import * as filterActions from "../../state/actions/filterActions"
import { Button } from "../themed-html-components"
import LocationTreeShape from "../../state/shapes/LocationTreeShape"

const IntroArea = styled.div`
  margin-left: 20px;
`
/** A treeview style multiple choice location picker */
class LocationPicker extends React.Component {
  static propTypes = {
    treeData: PropTypes.arrayOf(PropTypes.shape(LocationTreeShape)).isRequired,
    selectedValues: PropTypes.arrayOf(PropTypes.number).isRequired,
    theme: PropTypes.shape({
      primaryColor: PropTypes.string.isRequired,
      primaryColorHover: PropTypes.string.isRequired,
      navBackgroundColor: PropTypes.string.isRequired
    }).isRequired
  }

  state = {
    checkedKeys: [],
    searchText: "",
    flatData: [],
    defaultCheckedKeys: []
  }

  componentDidMount = () => {
    // The selected ids come in as an array of integers
    // but the tree checkbox control requires an array of strings
    // so map the prop value into the state.checked value
    // Internal state is required as we only want to change the value
    // in the store upon clicking "Submit"
    let selectedIds = []
    if (this.props.selectedValues && this.props.selectedValues.length > 0) {
      selectedIds = this.props.selectedValues.map(x => x.toString())
      this.setState({ defaultCheckedKeys: selectedIds })
    }

    // Flatten the tree data to make it easy to find labels to display
    // for selected value later
    const flatten = (items, depth, parentName, parentValue) => {
      const flat = []
      Array.from(items).forEach(item => {
        var flatItem = {
          value: Number(item.value),
          label: item.label,
          depth,
          parentValue: parentValue,
          locationPathName: parentName && parentName.length > 0 ? parentName : "",
          hasChildren: item.children && item.children.length > 0
        }
        flat.push(flatItem)
        if (flatItem.hasChildren) {
          flat.push(
            ...flatten(
              item.children,
              depth + 1,
              flatItem.locationPathName && flatItem.locationPathName.length > 0
                ? `${flatItem.locationPathName} > ${flatItem.label}`
                : flatItem.label,
              flatItem.value
            )
          )
        }
      })

      return flat
    }

    var flatData = flatten(this.props.treeData, 0, "", 0)

    this.setState({ flatData: flatData })
  }

  // Traverse the tree data to get the first selected label
  getDisplayTextValue(selectedIds) {
    if (!this.state.flatData || !selectedIds || selectedIds.length === 0) {
      return null
    }

    // Filter to just the selected items
    let selectedItems = this.state.flatData.filter(x => selectedIds.indexOf(x.value) >= 0)

    // Sort the selected items by depth and then alphabetically,
    // so we display the text of the topmost item
    selectedItems = selectedItems.sort((a, b) => {
      let compare = a.depth - b.depth
      if (compare === 0) {
        if (a.label < b.label) compare = -1
        if (a.label > b.label) compare = 1
      }
      return compare
    })

    let textToDisplay = selectedItems[0].label

    if (selectedIds.length > 1) {
      const remainingCount = selectedIds.length - 1
      // eslint-disable-next-line react/prop-types
      textToDisplay = `${textToDisplay} + ${remainingCount} ${this.props.t("Common.more")}`
    }

    return textToDisplay
  }

  closeModal = () => {
    this.props.closePopup() // eslint-disable-line react/prop-types
  }

  submitChanges = () => {
    let selectedIds = []
    let displayText = null
    if (this.state.checkedKeys && this.state.checkedKeys.length > 0) {
      selectedIds = this.state.checkedKeys.map(x => parseInt(x)) // eslint-disable-line radix
      displayText = this.getDisplayTextValue(selectedIds)
    }

    // eslint-disable-next-line react/prop-types
    this.props.changeValueLocations(selectedIds, displayText)

    this.closeModal()
  }

  onCheckChange = keys => {
    this.setState({ checkedKeys: keys })
  }
  render() {
    // eslint-disable-next-line react/prop-types
    const { t, theme, treeData } = this.props
    return (
      <div>
        <em>{t("Filters.LocationSelectSidebarText")}...</em>
        <Modal isOpen toggle={this.closeModal} className="modal-lg">
          <ModalHeader toggle={this.closeModal}>{t("Filters.LocationPopup.Title")}</ModalHeader>
          <ModalBody>
            <IntroArea>
              <em>{t("Filters.LocationPopup.Intro")}</em>
            </IntroArea>
            <TreeContainer
              treeData={treeData}
              flatData={this.state.flatData}
              theme={theme}
              defaultCheckedKeys={this.state.defaultCheckedKeys}
              onCheckChange={this.onCheckChange}
              useLargerCheckbox={true}
              showSelectAll={true}
            />
          </ModalBody>
          <ModalFooter>
            <Button inverted onClick={this.submitChanges}>
              {t("Common.Submit")}
            </Button>{" "}
            <ReactStrapButton color="secondary" onClick={this.closeModal}>
              {t("Common.Cancel")}
            </ReactStrapButton>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    // filterState: state.filters,
    theme: state.userDetail.theme
  }
}

function mapDispatchToProps(dispatch) {
  return {
    changeValueLocations: (selectedValues, displayText) =>
      dispatch(filterActions.changeValueLocations(selectedValues, displayText)),
    closePopup: () => dispatch(filterActions.setActiveField(null))
  }
}

export default compose(
  translate(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(LocationPicker)



// WEBPACK FOOTER //
// ./src/components/filters/LocationPicker.jsx